import { render, staticRenderFns } from "./ModalSubmit.vue?vue&type=template&id=0e9827b6&scoped=true&"
import script from "./ModalSubmit.vue?vue&type=script&lang=js&"
export * from "./ModalSubmit.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubmit.vue?vue&type=style&index=0&id=0e9827b6&prod&lang=scss&"
import style1 from "./ModalSubmit.vue?vue&type=style&index=1&id=0e9827b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9827b6",
  null
  
)

export default component.exports